export const colors = {
  neutral: {
    100: "#FFFFFF",
    200: "#F5F5F5",
    300: "#E9E9E9",
    400: "#C1C3C4",
    500: "#71767A",
    600: "#4A5152",
    700: "#202425",
  },
  teal: {
    400: "#CFDFDC",
    500: "#0D5E52",
  },
  green: {
    400: "#E6FFE8",
    500: "#00660A",
  },
  blue: {
    400: "#E8F0FF",
    500: "#275DC5",
  },
  yellow: {
    400: "#FFF5E2",
    500: "#A0581C",
  },
  red: {
    400: "#FFF1F1",
    500: "#DA1F1F",
  },
  gold: {
    500: "#FFBC33",
  },
  pink: {
    500: "#F3B0E9",
  },
  orange: {
    400: "#FF9740",
    500: "#BE532E",
  },
  aqua: {
    500: "#1AAAC5",
  },
  salmon: {
    500: "#F4D8D6",
  },
  // Superclinical
  purple: {
    400: "#F7E5FF",
    500: "#8E3CB5",
  },
};
